import React from "react";
import { Menu } from "semantic-ui-react";

import { Waveform } from "./Waveform";
import { LoopMenuItem } from "./LoopMenuItem";
import { PlaybackButtons } from "./PlaybackButtons";

export function Transport(props) {
  return (
    <>
      <LoopMenuItem />

      <PlaybackButtons />

      <Menu.Item style={props.basic ? { display: "none" } : undefined}>
        <Waveform id="waveform" />
      </Menu.Item>
    </>
  );
}
